import React from 'react';
import withErrorCatcher from '../../../components/Common/withErrorCatcher.js'
import { push } from 'react-router-redux';
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { Button, withStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import AppContent from '@components/App/appContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import PageContentWrapper from '@components/App/PageComponents/pageContentWrapper';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import AdminSettingsDrawer from '../../../components/App/Drawers/adminSettingsDrawer';
import AdminSettingsTitle from '../Common/AdminSettingsTitle.js';
import { withTranslation } from 'react-i18next';

const styles = theme => ({
    progress: {
        margin: `0 ${theme.spacing.unit * 2}px`,
        textAlign: 'center',
        align: 'center'
    },
    spinner: {
        textAlign: 'center',
        paddingTop: 16
    },
    paper: {
        padding: 16
    },
    paperStyle: {
        marginBottom: 40
    },
    listStyle: {
        paddingTop: 0,
        paddingBottom: 0
    },
    button: {
        margin: 16
    }
})

export class Archive extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      value: 'a',
      scores: [],
      storageUse: 0,
      docsCount: 0,
      isLoading: true,
      activity: [],
      sources: []
    }

  }

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    this.props.queryService.getDeletedItems().then((archives) => {
      this.setState({
        archives,//: archives.filter(a => a.value.type === "Delete"),
        isLoading: false
      })
    })
  }

  render() {
    const { classes,t } = this.props;
    const { archives } = this.state;

    const spinner = <div data-intrcm-id="archive_fwxtyqqb" className={classes.spinner}>
            <CircularProgress className={classes.progress} />
        </div>
    let content = spinner;

    if(!this.state.isLoading){
      content = <Table className={classes.table}>
        <TableHead>
            <TableRow>
                <TableCell>{t('Title')}</TableCell>
                <TableCell>{t('User')}</TableCell>
                <TableCell>{t('Update date')}</TableCell>
                <TableCell>{t('Type')}</TableCell>
                <TableCell>{t('Restore')}</TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
          {archives.map(archive => {
            return (
                <TableRow key={archive.id}>
                    <TableCell component="th" scope="row"> {archive.value.document.title} </TableCell>
                    <TableCell>{archive.value.userName}</TableCell>
                    <TableCell numeric>{archive.value.dateTime}</TableCell>
                    <TableCell>{t(archive.value.type)}</TableCell>
                    <TableCell><Button onClick={()=>{this.props.queryService.restoreItem(archive.value.docId).then(()=>{this.loadData()})}}>Restore</Button> </TableCell>
                </TableRow>
            );
          })}
        </TableBody>
      </Table>
    }

    return <AppContent >
            <PageContentWrapper drawer={<AdminSettingsDrawer selected="archive"/>}>
                <Grid  spacing={16}>
                <AdminSettingsTitle text={t('Archive')} />
                        <Paper className={classes.paperStyle}>
                            { content }
                        </Paper>
                    </Grid>
            </PageContentWrapper>
      </AppContent>;
    }
}
const mapStateToProps = (state) => ({
  ...state.services,
  templates: state.globalData.templates

})

const mapDispatchToProps = dispatch => {
  return {
    goTo: path => { dispatch(push(path)) },

    dispatch: dispatch
  }
}

export default compose(withStyles(styles),
withTranslation('admin'),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ))(Archive);